/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { GraphUserResponseNormalized } from '../models/graph-user-response-normalized';

@Injectable({
  providedIn: 'root',
})
export class GraphApiService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getUsersFromGraph
   */
  static readonly GetUsersFromGraphPath = '/graph/users';

  /**
   * Retrieve Users from Graph API.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUsersFromGraph()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsersFromGraph$Response(params: {

    /**
     * User ID (email).
     */
    issuerAssignedId: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<GraphUserResponseNormalized>> {

    const rb = new RequestBuilder(this.rootUrl, GraphApiService.GetUsersFromGraphPath, 'get');
    if (params) {
      rb.query('issuerAssignedId', params.issuerAssignedId, {});
      rb.header('x-tenant-id', params['x-tenant-id'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json; charset&#x3D;utf-8',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GraphUserResponseNormalized>;
      })
    );
  }

  /**
   * Retrieve Users from Graph API.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUsersFromGraph$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsersFromGraph(params: {

    /**
     * User ID (email).
     */
    issuerAssignedId: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;
  },
  context?: HttpContext

): Observable<GraphUserResponseNormalized> {

    return this.getUsersFromGraph$Response(params,context).pipe(
      map((r: StrictHttpResponse<GraphUserResponseNormalized>) => r.body as GraphUserResponseNormalized)
    );
  }

  /**
   * Path part for operation patchRoles
   */
  static readonly PatchRolesPath = '/graph/patch-role';

  /**
   * Update user claims via the graph API.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchRoles()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchRoles$Response(params: {

    /**
     * User ID.
     */
    userId: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * JSON object of user properties to update.
     */
    body: {
}
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, GraphApiService.PatchRolesPath, 'post');
    if (params) {
      rb.query('userId', params.userId, {});
      rb.header('x-tenant-id', params['x-tenant-id'], {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Update user claims via the graph API.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchRoles$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchRoles(params: {

    /**
     * User ID.
     */
    userId: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * JSON object of user properties to update.
     */
    body: {
}
  },
  context?: HttpContext

): Observable<void> {

    return this.patchRoles$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation patchTenants
   */
  static readonly PatchTenantsPath = '/graph/patch-tenants';

  /**
   * Update user claims via the graph API.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchTenants()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchTenants$Response(params: {

    /**
     * User ID.
     */
    userId: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * JSON object of user properties to update.
     */
    body: {
}
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, GraphApiService.PatchTenantsPath, 'post');
    if (params) {
      rb.query('userId', params.userId, {});
      rb.header('x-tenant-id', params['x-tenant-id'], {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Update user claims via the graph API.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchTenants$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchTenants(params: {

    /**
     * User ID.
     */
    userId: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * JSON object of user properties to update.
     */
    body: {
}
  },
  context?: HttpContext

): Observable<void> {

    return this.patchTenants$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
